export const getBoundingClientRect = el => {
  const {
    top,
    right,
    bottom,
    left,
    width,
    height,
    x,
    y
  } = el.getBoundingClientRect();

  /**
   * В задаче UIKIT-6113 был добавлен мобильный вариант Tooltip,
   * который имеет анимацию появления scale(0.5) -> scale(1).
   * Из-за этого getBoundingClientRect возвращает нам не совсем те
   * координаты и Popover позиционируются в ту точку, как будто
   * его ширина и высота в два раза меньше.
   * Тут предложена попытка корректировать значения, возвращаемые
   * getBoundingClientRect в зависимости от текущих стилей трансформации.
   * if (transformMatrix) должен отработать только для Popover с параметрами
   * variant === "ios" or variant === "android".
   */
  const style = getComputedStyle(el);
  const transformMatrix = style.getPropertyValue('transform');
  if (transformMatrix) {
    if (transformMatrix.startsWith('matrix(')) {
      const ta = transformMatrix.slice(7, -1).split(/, /);
      const scaleX = +ta[0];
      const scaleY = +ta[3];
      const dx = +ta[4];
      const dy = +ta[5];
      const transformOrigin = style.getPropertyValue('transform-origin');
      const updatedX = x - dx - (1 - scaleX) * parseFloat(transformOrigin);
      const updatedY = y - dy - (1 - scaleY) * parseFloat(transformOrigin.slice(transformOrigin.indexOf(' ') + 1));
      const updatedWidth = scaleX ? width / scaleX : el.offsetWidth;
      const updatedHeight = scaleY ? height / scaleY : el.offsetHeight;
      return {
        top: updatedY,
        right: updatedX + updatedWidth,
        bottom: updatedY + updatedHeight,
        left: updatedX,
        width: updatedWidth,
        height: updatedHeight,
        x: updatedX,
        y: updatedY
      };
    }
    return {
      top,
      right,
      bottom,
      left,
      width,
      height,
      x,
      y
    };
  }
  return {
    top,
    right,
    bottom,
    left,
    width,
    height,
    x,
    y
  };
};